/***
 * 將 Server 取回的資料透過 tour_key, group_code 比對是否有一樣的產品
 * 如果有，就將從 Server 取回的資料覆寫至 Google Seet 的資料
 */
export function tourProductMappingCombination() {
  // 根據 tour_key, group_code 將自後端取得的旅遊產品資訊覆蓋到 sheet 取得的產品上
  let _tourMapping = async function (server_result, theme_product_detail_list) {
    console.log("server_result", server_result)
    theme_product_detail_list.forEach(function (product_list) {
      product_list.forEach(function (product_item) {
        let product = product_item;
        let group_code = product.group_code;
        let tour_key = product.tour_key;

        // 判斷 server_result 是否有以下兩條件的值
        // true: 將 server 的 title, price, photo 覆寫至對應的產品
          if (server_result[tour_key] !== null && server_result[tour_key] && server_result[tour_key][group_code]) {
            let server_tour = server_result[tour_key][group_code];
            product_item.product_name = server_tour.title;
            product_item.current_price = server_tour.price;
            product_item.product_photo = server_tour.photo;
          }
      });
    });

    return theme_product_detail_list;
  };
  return {
    tourMapping: _tourMapping,
  };
}
